import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Tab from 'react-bootstrap/Tab';
import Dropdown from 'react-bootstrap/Dropdown';
import Collapse from 'react-bootstrap/Collapse';


const Input = Form.Control;
const Range = Form.Range;
const Textarea = Form.Text;
const Select = Form.Select;
const Checkbox = Form.Check;
const Radio = Form.Check;
const Label = Form.Label;

export { Card, Button, Container, Row, Col, Input, Range, Textarea, Select, Checkbox, Radio, Label, Nav, Navbar, NavDropdown, Tab, Dropdown, Collapse  }